// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 152 ? "about" : chunkId) + "." + {"92":"ae854140","152":"68ba2d36","540":"908d0fef","680":"dc3f5332","736":"8db420ee"}[chunkId] + ".css";
};